import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { CompanyProvider } from "@/contexts/CompanyContext";
import { OutletProvider } from "@/contexts/OutletContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import BukuStock from "@/pages/BukuStock";
import Penjualan from "@/pages/Penjualan";
import Pembelian from "@/pages/Pembelian";
import Harga from "@/pages/Harga";
import LabaRugi from "@/pages/LabaRugi";
import ArusKas from "@/pages/ArusKas";
import DaftarAset from "@/pages/DaftarAset";
import UserManagement from "@/pages/UserManagement";
import Neraca from "@/pages/Neraca";
import BukuBesar from "@/pages/BukuBesar";
import COA from "@/pages/COA";
import Rekonsiliasi from "@/pages/Rekonsiliasi";
import JurnalUmum from "@/pages/JurnalUmum";
import NeracaAwal from "@/pages/NeracaAwal";
import Company from "@/pages/Company";
import Outlets from "@/pages/Outlets";
import JurnalApproval from "@/pages/JurnalApproval";
import RekeningKoran from "@/pages/RekeningKoran";
import NotificationSettings from "@/pages/NotificationSettings";

const Guard = ({ children, adminOnly }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === undefined) return <div className="min-h-screen grid place-items-center text-slate-500">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc }} />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

const App = () => (
  <div className="App">
    <BrowserRouter>
      <AuthProvider>
        <CompanyProvider>
          <OutletProvider>
            <Toaster richColors position="top-right" />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<Guard><Layout /></Guard>}>
                <Route index element={<Dashboard />} />
                <Route path="/buku-stock" element={<BukuStock />} />
                <Route path="/rekonsiliasi" element={<Rekonsiliasi />} />
                <Route path="/penjualan" element={<Penjualan />} />
                <Route path="/pembelian" element={<Pembelian />} />
                <Route path="/harga" element={<Guard adminOnly><Harga /></Guard>} />
                <Route path="/coa" element={<COA />} />
                <Route path="/jurnal-umum" element={<JurnalUmum />} />
                <Route path="/jurnal-approval" element={<Guard adminOnly><JurnalApproval /></Guard>} />
                <Route path="/rekening-koran" element={<RekeningKoran />} />
                <Route path="/buku-besar" element={<BukuBesar />} />
                <Route path="/neraca-awal" element={<NeracaAwal />} />
                <Route path="/laba-rugi" element={<LabaRugi />} />
                <Route path="/neraca" element={<Neraca />} />
                <Route path="/arus-kas" element={<ArusKas />} />
                <Route path="/aset" element={<DaftarAset />} />
                <Route path="/company" element={<Guard adminOnly><Company /></Guard>} />
                <Route path="/outlets" element={<Guard adminOnly><Outlets /></Guard>} />
                <Route path="/notifications" element={<NotificationSettings />} />
                <Route path="/users" element={<Guard adminOnly><UserManagement /></Guard>} />
              </Route>
            </Routes>
          </OutletProvider>
        </CompanyProvider>
      </AuthProvider>
    </BrowserRouter>
  </div>
);

export default App;
